import MemorizedCell from './MemorizedCell';

export default MemorizedCell;
